import React from "react";
import { Button, Container } from "reactstrap";
import AssessmentHeader from "../../Diet/component/AssessmentHeader";
import waveImg from "../../../assets/images/wave.svg";
import { Link } from "react-router-dom";

const MandatoryInfo = () => {
  return (
    <>
      <AssessmentHeader progressPer={10} />
      <Container className="diet-container mb-6-rem text-center">
        <div className="mt-5 mb-3">
          <img src={waveImg} alt="" />
        </div>
        <h4 className="header-text mb-1">Let’s customise your diet plan</h4>
        <h2 className="assessment-page-title">
          It is mandatory for you to complete this section so that we can
          personlize your AI diet plan
        </h2>
        <div className="empty-space-82"></div>
        <div className="fix-div-button">
          <Link to="/dietPlan/healthConditions">
            <Button className="risk-btn">Let’s start</Button>
          </Link>
        </div>
      </Container>
    </>
  );
};

export default MandatoryInfo;
